import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Button from 'aria-viewer/tour/components/buttons/button'
import Icon from 'aria-viewer/tour/components/icon'
import VideoVolumeBar from '../bars/VideoVolumeBar'
import OpacityHelper from 'aria-viewer/tour/components/opacityHelper'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import * as VideoPlayerActions from '../../actions/videoActions'
import { VOLUME_BUTTON_INDEX, VIDEO_VOLUME_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'

// TODO : when videoPlayer is put into state,
// TODO   we can directly modify player volume
// TODO   in the reducer instead of in a component

class VideoVolumeButton extends PureComponent {
    constructor(props) {
        super(props)

        this.volumeHeight = this.props.volumeHeight || 140 * (window.innerHeight / 854)
        this.state = { isVolumeBarVisible: false }
    }

    static defaultProps = { volumeFadeOutTime: 2000 }

    handleOnClick = e => {
        e && e.stopPropagation && e.stopPropagation()
        e && e.nativeEvent && e.nativeEvent.stopImmediatePropagation()
        e && e.preventDefault && e.preventDefault()

        this.props.onClick && this.props.onClick(e)
        this.props.toggleVideoVolumeMuted()
    }
    registerProps = ({ isVideoVolumeMuted, videoVolume, player, setVideoVolume }) => {
        let nextVolume
        if (this.props.isVideoVolumeMuted != isVideoVolumeMuted || this.props.videoVolume != videoVolume) {
            if (isVideoVolumeMuted) {
                nextVolume = 0
            } else {
                nextVolume = videoVolume
            }
        }

        setVideoVolume(nextVolume)
        player.setVolume(nextVolume / 100.0)
    }

    // Listening for changes to volume/muting to funnel to player from this
    // component;
    componentWillReceiveProps(newProps) {
        this.registerProps(newProps)
    }

    handleVolumeChange = newVolume => {
        this.props.setVideoVolume(newVolume)
    }

    toggleVolumeBar = (e, isVolumeBarVisible) => {
        this.props.onChange && this.props.onChange(e)
        this.setState({ isVolumeBarVisible })
    }

    handleOnMouseOver = e => {
        this.toggleVolumeBar(e, true)
    }

    handleOnMouseOut = e => {
        this.toggleVolumeBar(e, false)
    }

    handleChange = e => {
        this.props.onChange && this.props.onChange()
    }

    render() {
        return (
            <Button
                onClick={this.handleOnClick}
                tabIndex={VIDEO_VOLUME_BUTTON_INDEX}
                onMouseOver={this.handleOnMouseOver}
                onMouseOut={this.handleOnMouseOut}
                theme="video_button"
                style={this.props.style}
            >
                <Icon icon={this.props.isVideoVolumeMuted ? 'volumeOff' : 'volumeOn'} />
                {this.props.children}
                <OpacityHelper test={this.state.isVolumeBarVisible}>
                    <VideoVolumeBar
                        onVolumeChange={this.handleVolumeChange}
                        player={this.props.player}
                        onChange={this.handleChange}
                        style={{
                            position: 'relative',
                            bottom: this.volumeHeight + 80,
                            right: '7px',
                        }}
                        volumeFadeOutTime={this.props.volumeFadeOutTime}
                        theme={this.props.theme}
                        volumeHeight={this.volumeHeight}
                    />
                </OpacityHelper>
            </Button>
        )
    }
}

export default connect(
    mapSelectorsToProps(['videoVolume', 'isVideoVolumeMuted']),
    {
        setVideoVolume: VideoPlayerActions.setVideoVolume,
        toggleVideoVolumeMuted: VideoPlayerActions.toggleVideoVolumeMuted,
    }
)(VideoVolumeButton)
